import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { Typography, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Header from '../../components/HeaderView';
import { ddiCountries } from './ddi';
import Profile from './Profile';
import Account from './Account';
import Business from './Business';
import Addresses from './Addresses';
import Sent from './Sent';
import Users from './Users';

import api from '../../services/api';

import ModalMessage from '../../components/ModalMessage';

import useUserContext from '../../hooks/useUserContext';

const crypto = require('crypto');

const NavBar = ({ step, setStep, handleNext, loading }) => {
  const RightArrow = ({ style, black }) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
      >
        <path
          d="M16 8L24 16L16 24"
          stroke={black ? 'black' : 'white'}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24 16L8 16"
          stroke={black ? 'black' : 'white'}
          strokeLinecap="round"
        />
      </svg>
    );
  };

  return (
    <Grid
      container
      justifyContent="flex-end"
      style={{ width: '100%', height: 72, padding: 16 }}
    >
      <Grid>
        {step !== 0 && step !== 3 && (
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{
              width: 113,
              height: 40,
              background: '#fff',
              cursor: 'pointer',
              marginRight: 16,
              border: '1px solid #000',
              position: 'relative',
              zIndex: 1000,
            }}
            onClick={() => {
              if (step === 0) return;
              setStep(step - 1);
            }}
          >
            <RightArrow
              black
              style={{
                position: 'relative',
                transform: 'rotate(180deg)',
                marginRight: 0,
                right: 8,
              }}
            />

            <Typography
              style={{ position: 'relative', bottom: 2.5, right: 4 }}
              align="center"
            >
              Back
            </Typography>
          </Grid>
        )}
      </Grid>
      <Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{
            width: 113,
            height: 40,
            background: '#000',
            cursor: 'pointer',
          }}
          onClick={handleNext}
        >
          {loading ? (
            <CircularProgress size={25} style={{ color: '#fff' }} />
          ) : (
            <>
              <Typography
                align="center"
                style={{
                  color: '#fff',
                  position: 'relative',
                  bottom: step !== 2 && step !== 5 && 2.5,
                  left: step !== 2 && step !== 5 && 4,
                }}
              >
                {step === 2 ? 'Apply' : step === 5 ? 'Finish' : 'Next'}
              </Typography>
              {step !== 2 && step !== 5 && (
                <RightArrow
                  style={{ position: 'relative', marginRight: 0, left: 8 }}
                />
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

const validatePhoneField = state => {
  const regexPhone = /^[0-9]+$/; // accept at least 1 number
  return regexPhone.test(state.phone);
};

const validateCountryCodeField = state => {
  const regexCountryCode = /^\+[\d]+$/;
  return regexCountryCode.test(state.countryCode);
};

const validateRegexPasswordField = state => {
  const regexPassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  return regexPassword.test(state.password);
};

const validateEmail = state => {
  const regexemail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return regexemail.test(state.email);
};

const validatePasswordEquality = state => {
  return state.password === state.confirmPass && state.password !== '';
};

const validateEmptyField = field => {
  return field.length === 0;
};

const useStyles = makeStyles(() => ({
  dasboardMenu: {
    padding: 24,
    backgroundColor: 'white',
    // maxHeight: '287px',
  },
  menu: {
    padding: 24,
    backgroundColor: 'white',
    maxWidth: '23%',
    position: 'relative',
    top: `100px`,
  },

  gridMenuItem: {
    marginTop: 12,
  },

  dashboardContent: {
    position: 'absolute',
    top: `114px`,
    bottom: '72px',
    padding: '0px 36px',
  },
  dashboardContentMobile: {
    position: 'absolute',
    top: `64px`,
    padding: 0,
    justifyContent: 'center',
  },

  pagesContent: {
    padding: '0px 36px',
  },
  typographyMenuItem: {
    cursor: 'pointer',
  },
  boldMenuItem: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    lineHeight: '14px',
    cursor: 'pointer',
  },
  menuTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: 24,
    lineHeight: '32px',
  },
  centralTitle: {
    textAlign: 'center',
  },

  contentCardText: {
    fontSize: 12,
    lineHeight: '18px',
  },
  container: {
    width: window.innerWidth - 380,
    background: '#ffffff',
    padding: '12px 16px 64px',
    maxHeight: window.innerHeight - 235,
    alignItems: 'flex-start',
    marginLeft: 20,
  },
  containerMobile: {
    width: '100%',
  },
  stepOptions: {
    fontSize: 14,
    cursor: 'pointer',
  },
  stepOptionsSelected: {
    fontSize: 14,
    fontWeight: 'bold',
    paddingBottom: '4px',
    borderBottom: '2px solid',
    cursor: 'pointer',
  },
  disabled: {
    fontSize: 14,
    color: '#bdbdbd',
  },
}));

export default function ClientArea() {
  const { userState, finishUserRegister } = useUserContext();
  const { user: profile } = userState;

  const history = useHistory();

  const handleProfileAddresses = () => {
    return profile.account.addresses.map(address => ({
      modalAddress: address.name,
      modalStreet: address.street,
      modalCity: address.city,
      modalCountry: address.country,
      modalStoreProv: address.state_province,
      modalUnit: address.building_unit_floor,
      modalZipcode: address.zipcode,
      isBillingAddress: address.isBillingAddress,
      isShippingAddress: address.isShippingAddress,
    }));
  };

  const [step, setStep] = useState(userState.token ? 3 : 0);

  const [country, setCountry] = useState('');

  const [state, setState] = useState({
    firstName: '',
    lastName: '',
    email: '',
    countryCode: '+',
    phone: '',
    role: 'Buyer',
    password: '',
    confirmPass: '',
    shopName: '',
    website: '',
    facebook: '',
    instagram: '',
    radioBuyingSeason: 'Online',
    isOnJOOR: 'false',
    joorURL: '',
    inBusinessSince: 2022,
    brandsSold: 1,
    numDoors: 1,
    brandsCarried: '',
    costumersProfile: '',
    files: [],
    unitStoreSize: 'm',
    storeSize: '',
    doorsAddress: userState.token ? handleProfileAddresses() : [],
    storeProfile: '',
    freightCompany: '',
    freightFirstName: '',
    freightLastName: '',
    freightEmail: '',
    freightDDI: '+',
    freightPhone: '',
    freightStreet: '',
    freightUnit: '',
    freightCity: '',
    freightState: '',
    freightZip: '',
    freightCountry: '',
    payableFirstName: '',
    payableLastName: '',
    payableEmail: '',
    payableDDI: '+',
    payablePhone: '',
    isApproved: '',
    loading: false,
    users: [
      {
        name: profile?.name,
        isApproved: profile?.isApproved,
        email: profile?.email,
        ddi: profile?.countryCode,
        phone: profile?.phone,
        role: 'Buyer',
      },
    ],
  });

  const [error, setError] = useState({
    countryCode: false,
    phone: false,
    // currentPassword: false,
    password: false,
    confirmPass: false,
    firstName: false,
    lastName: false,
    email: false,
    shopName: false,
    buyingSeason: false,
    interest: false,
    brandsCarried: false,
    costumersProfile: false,
    storeProfile: false,
  });

  const [arrayBuyingSeason, setArrayBuyingSeason] = useState([]);
  const [arrayInterest, setArrayInterest] = useState([]);
  const [openMessage, setOpenMessage] = React.useState(false);
  const [wid, setWid] = React.useState(0);
  React.useLayoutEffect(() => {
    setWid(window.innerWidth);
  }, [wid]);

  const classes = useStyles({ wid });

  const user = {
    name: `${state.firstName} ${state.lastName}`,
    email: state.email,
    role: state.role,
    countryCode: state.countryCode,
    phone: state.phone,
  };

  const handleAddUser = async user => {
    await api.post('/newCostumers', {
      name: user.name,
      email: user.email,
      phone: user.phone,
      countryCode: user.ddi,
      role: user.role,
      accountId: profile?.account?._id,
      account: profile?.account,
      isInvited: true,
      message: user.informations,
    });
    setState({ ...state, users: [...state.users, user] });
  };

  const handleChangeRadio = value => {
    setState({ ...state, radioBuyingSeason: value });
  };

  const changeDocuments = e => {
    if (e.target.files && e.target.files?.length > 0) {
      const filesURL = [];
      const filess = state.files;
      let stop = false;
      [...e.target.files].map(file => {
        if (file.size > 5 * 1000 * 1000) {
          stop = true;
          alert('Image can not be larger than 2MB');
        }
        filesURL.push(URL.createObjectURL(file));
        return filess.push(file);
      });
      if (!stop) setState({ ...state, files: filess });
    }
  };

  const handleChangeBuyingSeason = value => {
    setError({ ...error, buyingSeason: false });
    if (arrayBuyingSeason?.includes(value)) {
      return setArrayBuyingSeason(
        arrayBuyingSeason.filter(item => item !== value)
      );
    }
    return setArrayBuyingSeason([...arrayBuyingSeason, value]);
  };

  const handleChangeInterest = value => {
    setError({ ...error, interest: false });
    if (arrayInterest?.includes(value)) {
      return setArrayInterest(arrayInterest.filter(item => item !== value));
    }
    return setArrayInterest([...arrayInterest, value]);
  };

  const countryByDdi = countryCode => {
    const countryDdi = ddiCountries.find(
      object => object.dial_code === countryCode
    );
    if (countryDdi !== undefined) setCountry(`(${countryDdi.code})`);
  };

  const handleChange = e => {
    const { name } = e.target;
    const { value } = e.target;

    if (
      (name === 'countryCode' ||
        name === 'freightDDI' ||
        name === 'payableDDI') &&
      value.length >= 3
    )
      countryByDdi(value);
    else if (
      (name === 'countryCode' ||
        name === 'freightDDI' ||
        name === 'payableDDI') &&
      value.length <= 1
    ) {
      setState({ ...state, [name]: '+' });
      setError({ ...error, [name]: false });
      return;
    } else if (
      name === 'countryCode' ||
      name === 'freightDDI' ||
      name === 'payableDDI'
    )
      setCountry('');

    setState({ ...state, [name]: value });
    setError({ ...error, [name]: false });

    if (error.name) setError({ ...error, [name]: false });
  };

  const validateProfileInput = async () => {
    const objectError = {
      countryCode: !validateCountryCodeField(state),
      phone: !validatePhoneField(state),
      firstName: validateEmptyField(state.firstName),
      lastName: validateEmptyField(state.lastName),
      password: !validateRegexPasswordField(state),
      confirmPass: !validatePasswordEquality(state),
      email: !validateEmail(state),
      // currentPassword: validateEmptyField(state.currentPassword),
    };

    if (
      objectError.countryCode ||
      objectError.phone ||
      objectError.firstName ||
      objectError.lastName ||
      objectError.password ||
      objectError.confirmPass ||
      objectError.email
    )
      return setError({
        countryCode: objectError.countryCode,
        phone: objectError.phone,
        password: !validateRegexPasswordField(state),
        confirmPass: !validatePasswordEquality(state),
        firstName: objectError.firstName,
        lastName: objectError.lastName,
        email: objectError.email && 'Invalid email format',

        // currentPassword: validateEmptyField(state.currentPassword),
      });
    try {
      const response = await api.get(`/checkCustomerEmail/${state.email}`);
      console.log('response', response);
      if (response.data) {
        return setError({ ...error, email: 'Email is already in use' });
      }
    } catch {}
    return setStep(1);
  };

  const validateAccountInput = async () => {
    if (validateEmptyField(state.shopName)) {
      return setError({ shopName: 'Shop Name is required. Ex: FARM RIO' });
    }
    try {
      const response = await api.get(`/account/${state.shopName}`);
      if (response.data) {
        setOpenMessage(true);
        return setError({ shopName: 'Account name is already in use' });
      }
    } catch {}

    return setStep(2);
  };

  const validateBusinesss = () => {
    const objectError = {
      buyingSeason: arrayBuyingSeason.length === 0 && 'Choose a season to buy',
      interest: arrayInterest.length === 0 && 'Choose an interest',
      joorURL:
        state.isOnJOOR === 'true' &&
        validateEmptyField(state.joorURL) &&
        'Insert your JOOR profile',
      brandsCarried:
        validateEmptyField(state.brandsCarried) &&
        'Insert brands currently carried',
      costumersProfile:
        validateEmptyField(state.costumersProfile) &&
        'Customer profile is required',
      storeProfile:
        state.radioBuyingSeason !== 'Online' &&
        validateEmptyField(state.storeProfile) &&
        'Store profile is required',
      doorsAddress:
        state.radioBuyingSeason !== 'Online' &&
        state.doorsAddress.length !== state.numDoors &&
        'Insert all doors address',
      storeSize:
        state.radioBuyingSeason !== 'Online' &&
        validateEmptyField(state.storeSize) &&
        'Store size is required',
    };

    const hasErrors = Object.values(objectError).some(error => error);

    if (hasErrors) {
      setError({
        buyingSeason: objectError.buyingSeason,
        interest: objectError.interest,
        joorURL: objectError.joorURL,
        brandsCarried: objectError.brandsCarried,
        costumersProfile: objectError.costumersProfile,
        storeProfile: objectError.storeProfile,
        doorsAddress: objectError.doorsAddress,
        storeSize: objectError.storeSize,
      });
      return false;
    }
    return true;
  };

  const handleRequest = async () => {
    if (!validateBusinesss()) return;
    setState({ ...state, loading: true });

    const typedAddress = state.doorsAddress.map(address => ({
      name: address.modalAddress,
      city: address.modalCity,
      country: address.modalCountry,
      state_province: address.modalStoreProv,
      street: address.modalStreet,
      building_unit_floor: address.modalUnit,
      zipcode: address.modalZipcode,
    }));

    const data = new FormData();
    data.append('name', state.shopName);
    data.append('buyingSeason', JSON.stringify(arrayBuyingSeason));
    data.append('yearsInBusiness', state.inBusinessSince);
    data.append('website', state.facebook);
    data.append('facebook', state.shopName);
    data.append('instagram', state.instagram);
    data.append('costumersProfile', state.costumersProfile);
    data.append('storeProfile', state.storeProfile);
    data.append('brandsCarried', state.brandsCarried);
    data.append('brandsCurrentlySold', state.brandsSold);
    data.append('doorsAddress', JSON.stringify(typedAddress));
    data.append('storeSize', `${state.storeSize} ${state.unitStoreSize}`);
    data.append('joorURL', state.joorURL);
    data.append('interest', JSON.stringify(arrayInterest));

    state.files.forEach(doc => {
      const newFile = new File(
        [doc],
        `${crypto.randomBytes(10).toString('HEX')}-${doc.name}`,
        { type: 'image/jpeg' }
      );
      data.append('images', newFile);
    });
    const account = await api.post('/account', data);
    await api.post('/newCostumers', {
      name: `${state.firstName} ${state.lastName}`,
      email: state.email,
      phone: state.phone,
      countryCode: state.countryCode,
      role: state.role,
      password: state.password,
      accountId: account.data?._id,
      account: account.data,
    });
    setState({ ...state, loading: false });

    setStep('sent');
  };

  const handleUpdate = async () => {
    const addresses = state.doorsAddress.map(address => ({
      name: address.modalAddress,
      street: address.modalStreet,
      city: address.modalCity,
      country: address.modalCountry,
      state_province: address.modalStoreProv,
      building_unit_floor: address.modalUnit,
      zipcode: address.modalZipcode,
      isBillingAddress: address.isBillingAddress,
      isShippingAddress: address.isShippingAddress,
    }));

    const freight = {
      company: state.freightCompany,
      name: `${state.freightFirstName} ${state.freightLastName}`,
      email: state.freightEmail,
      ddi: state.freightDDI,
      phone: state.freightPhone,
      address: {
        name: 'Freight',
        street: state.freightStreet,
        city: state.freightCity,
        country: state.freightCountry,
        state_province: state.freightState,
        zipcode: state.freightZip,
        building_unit_floor: state.freightUnit,
      },
    };

    const payable = {
      name: `${state.payableFirstName} ${state.payableLastName}`,
      email: state.payableEmail,
      ddi: state.payableDDI,
      phone: state.payablePhone,
    };

    setState({ ...state, loading: true });

    await finishUserRegister({
      id: profile.account,
      addresses,
      freight,
      payable,
      isFirstAccess: 'false',
    });

    history.push('/');
    setState({ ...state, loading: false });
  };

  const handleNext = () => {
    switch (step) {
      case 0:
        return validateProfileInput();
      case 1:
        return validateAccountInput();
      case 2:
        return handleRequest();
      case 5:
        return handleUpdate();
      default:
        setStep(step + 1);
    }
  };

  function HeaderContent({ step }) {
    return (
      <Grid
        container
        direction="column"
        alignItems="center"
        style={{
          background: `url("https://storage.googleapis.com/showroom-bucket-images/ALL/bg_register.jfif") no-repeat   fixed center  `,
          backgroundSize: 'cover',
          height:
            step !== 'sent' ? window.innerHeight - 72 : window.innerHeight,
        }}
      >
        {wid > 1024 ? (
          <Header home black />
        ) : (
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            onClick={() => history.push('/')}
            style={{ height: 64, background: '#fff' }}
          >
            <svg
              width="132"
              height="64"
              viewBox="0 0 132 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M109.398 30.2206L103.112 23.1829H99.3784V30.2206H98.9064V15.8448H105.322C106.595 15.8448 107.621 16.1808 108.401 16.8529C109.18 17.5251 109.571 18.412 109.571 19.5138C109.571 20.6147 109.18 21.5026 108.401 22.1738C107.621 22.8459 106.594 23.182 105.322 23.182H103.734L110.086 30.2196H109.398V30.2206ZM105.322 22.7533C106.466 22.7533 107.382 22.4566 108.069 21.8623C108.756 21.2691 109.099 20.4856 109.099 19.5129C109.099 18.5402 108.755 17.7567 108.069 17.1634C107.382 16.5691 106.466 16.2725 105.322 16.2725H99.3784V22.7523H105.322V22.7533Z"
                fill="black"
              />
              <path
                d="M113.196 30.2206V15.8448H113.668V30.2206H113.196Z"
                fill="black"
              />
              <path
                d="M129.878 17.7755C131.288 19.2055 131.991 20.9587 131.991 23.0322C131.991 25.1068 131.291 26.859 129.889 28.289C128.487 29.719 126.763 30.4345 124.718 30.4345C122.672 30.4345 120.946 29.719 119.536 28.289C118.127 26.859 117.423 25.1068 117.423 23.0322C117.423 20.9577 118.128 19.2055 119.536 17.7755C120.946 16.3455 122.672 15.63 124.718 15.63C126.749 15.63 128.469 16.3455 129.878 17.7755ZM129.546 27.9894C130.862 26.6452 131.52 24.9924 131.52 23.0332C131.52 21.0878 130.862 19.439 129.546 18.0869C128.231 16.7348 126.621 16.0587 124.718 16.0587C122.801 16.0587 121.185 16.7348 119.869 18.0869C118.554 19.439 117.896 21.0868 117.896 23.0332C117.896 24.9924 118.554 26.6452 119.869 27.9894C121.185 29.3347 122.801 30.0068 124.718 30.0068C126.62 30.0058 128.23 29.3337 129.546 27.9894Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.3487 25.4266C66.6256 25.3468 66.8799 25.2305 67.1174 25.0916C67.3716 24.9733 67.6279 24.8156 67.8447 24.6382C69.0273 23.7128 69.7743 22.2946 69.7743 20.7001C69.7743 20.3266 69.7359 19.9718 69.6561 19.6367C69.5763 19.3016 69.4787 18.9675 69.32 18.6512C68.5927 17.0369 67.0366 15.8947 65.1848 15.7567H63.1378L57.3863 15.738C57.0917 15.738 56.8157 15.8562 56.6186 16.0523C56.4225 16.2494 56.3032 16.5254 56.3032 16.8398V30.4084H58.4891V25.6829H63.9834L66.8 30.3897L66.8188 30.4084H69.3003L69.2796 30.37L66.3487 25.4266ZM58.4911 23.6931V17.706H64.8132C65.6411 17.706 66.3881 18.0421 66.9193 18.593C67.4515 19.1242 67.8053 19.8732 67.8053 20.7001V20.7198C67.8053 20.9356 67.7658 21.1327 67.7264 21.3495C67.689 21.5456 67.6091 21.7437 67.5303 21.9408C67.0967 22.886 66.191 23.5748 65.1079 23.6931H58.4911Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M52.721 30.3688C52.3071 29.3636 51.8735 28.3416 51.4596 27.3364C49.9231 23.7126 48.4074 20.0888 47.0494 16.4473L47.0287 16.4286C47.0099 16.3675 46.9705 16.3084 46.9508 16.2493C46.9104 16.2118 46.872 16.1517 46.8316 16.1123C46.6354 15.8757 46.3398 15.7388 46.0037 15.7388C45.9456 15.7388 45.9062 15.7388 45.847 15.7575C45.7889 15.7575 45.7288 15.7782 45.6696 15.7969C45.6095 15.8166 45.5514 15.8373 45.5129 15.856C45.2764 15.9743 45.0803 16.1901 44.9798 16.4473C43.603 20.0898 42.0863 23.7126 40.5686 27.3364C40.1349 28.3416 39.7033 29.3636 39.2884 30.3688L39.2697 30.4082H41.4743V30.3895L42.3819 28.2036H49.6482L50.5342 30.3895L50.5529 30.4082H52.7398L52.721 30.3688ZM43.1102 26.4297L46.0047 19.3211L48.9199 26.4297H43.1102Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.6272 22.9238C35.6854 22.9435 35.7652 22.9435 35.8233 22.9829C35.9032 23.0017 35.9603 23.0224 36.0205 23.0608C36.3151 23.2392 36.5122 23.5545 36.5122 23.928V24.0069C36.4925 24.0867 36.4925 24.1646 36.4531 24.2247C36.4344 24.3035 36.4137 24.3627 36.3743 24.4218C36.1978 24.7175 35.8815 24.9126 35.5277 24.9126H29.4037V30.4069H27.1971V16.8382C27.1971 16.5228 27.3341 16.2469 27.5312 16.0518C27.7293 15.8547 28.0042 15.7364 28.3009 15.7364H38.9346V17.7055H29.4037V22.9238H35.6272Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M75.4868 15.4804C75.6435 15.4804 75.8012 15.5198 75.9402 15.5789C75.9796 15.5987 76.019 15.6174 76.0584 15.6391C76.2753 15.7563 76.4319 15.9337 76.5295 16.1703L82.1431 25.5248L87.7359 16.1703C87.7556 16.1111 87.794 16.052 87.8344 16.0126C87.8551 15.9544 87.8926 15.914 87.932 15.8549C88.1488 15.6391 88.4445 15.4804 88.7805 15.4804H88.8003C88.8978 15.4804 88.9776 15.4991 89.0565 15.5198C89.1343 15.5395 89.2132 15.5592 89.292 15.5987C89.6468 15.776 89.9021 16.1505 89.9415 16.5625V30.4071H87.7359V19.6156C87.1052 20.68 86.4951 21.7631 85.8851 22.8462C84.9577 24.4812 84.0343 26.1161 83.0685 27.7107L83.0478 27.7304C83.029 27.7886 82.9886 27.829 82.9689 27.8684C82.9295 27.9078 82.8911 27.9265 82.8507 27.967C82.6526 28.1256 82.417 28.2232 82.1411 28.2232H82.1036C82.0455 28.2232 81.9854 28.2232 81.9459 28.2035C81.8868 28.2035 81.8287 28.1838 81.7883 28.1641C81.5527 28.0852 81.3546 27.9265 81.2176 27.7117C80.1937 26.056 79.2092 24.3235 78.2443 22.6106C77.6747 21.6064 77.1218 20.6012 76.5502 19.6166V30.4091H74.3456V16.5625C74.3456 16.4846 74.3653 16.4058 74.384 16.3279C74.4037 16.2481 74.4432 16.1703 74.4826 16.1111C74.659 15.7366 75.0542 15.4804 75.4868 15.4804Z"
                fill="black"
              />
              <path
                d="M14.3308 24.507C14.3308 23.5786 13.9701 22.7064 13.3147 22.0511C12.6564 21.3927 11.7852 21.0301 10.8627 21.0301C9.9373 21.0301 9.0661 21.3927 8.40777 22.0501C7.7524 22.7005 7.39071 23.5727 7.39071 24.506C7.39071 25.4314 7.75141 26.3016 8.40679 26.958C9.06216 27.6134 9.93434 27.9741 10.8627 27.9741C11.7881 27.9741 12.6583 27.6134 13.3147 26.959C13.9701 26.3036 14.3308 25.4334 14.3308 24.507ZM8.24812 24.507C8.24812 23.8053 8.52012 23.148 9.01485 22.6581C9.50564 22.1634 10.162 21.8914 10.8637 21.8914C11.5595 21.8914 12.2139 22.1644 12.7086 22.6591C13.2023 23.1489 13.4743 23.8053 13.4743 24.508C13.4743 25.2038 13.2023 25.8581 12.7076 26.3519C12.2139 26.8456 11.5595 27.1176 10.8637 27.1176C10.162 27.1176 9.50564 26.8456 9.01584 26.3519C8.52012 25.8572 8.24812 25.2028 8.24812 24.507Z"
                fill="black"
              />
              <path
                d="M21.1181 31.0736V30.0713L21.0157 30.0476L20.9339 30.0289C20.7693 29.9905 20.5751 29.9451 20.3554 29.8899C20.1977 29.8515 20.0508 29.8151 19.9109 29.7806C19.7828 29.748 19.6606 29.7185 19.5393 29.6899C19.2831 29.6239 19.0032 29.5677 18.6603 29.5125C18.3567 29.4632 18.0502 29.4258 17.7506 29.4001C16.1413 29.2681 14.4895 29.4425 12.9748 29.9057C10.2922 30.7257 8.24329 31.2569 6.32349 31.3732C4.49535 31.4835 2.82785 31.2174 0.730655 30.7503L0.601551 30.7217L0.441897 30.6872V31.6954L0.545376 31.7191L0.627175 31.7368C2.77167 32.2197 4.47268 32.4967 6.32645 32.3833C8.24723 32.269 10.2892 31.7378 12.958 30.9198L12.9708 30.9178L12.9787 30.9169L12.9866 30.9149C13.5641 30.7375 14.1801 30.6005 14.8197 30.5069C16.4428 30.2704 18.0758 30.3374 19.5423 30.701L19.6586 30.7296C19.9257 30.7947 20.1632 30.8528 20.3534 30.9011L20.4904 30.9336C20.5958 30.9592 20.7082 30.9868 20.8304 31.0125L20.9575 31.041L21.1181 31.0736Z"
                fill="black"
              />
              <path
                d="M3.24894 30.5911C3.22923 30.5142 3.20952 30.4324 3.18981 30.3417C3.13659 30.0816 3.10998 29.8194 3.10998 29.5622C3.10998 29.442 3.11688 29.3119 3.12969 29.167C3.14743 29.0241 3.1632 28.9009 3.18981 28.7757C3.22135 28.6309 3.25387 28.5057 3.29033 28.3914C3.32778 28.2761 3.37213 28.1421 3.42732 28.0198C3.46871 27.9105 3.51996 27.8149 3.57416 27.7183C3.62837 27.6148 3.67961 27.5162 3.74564 27.4216C3.78901 27.3487 3.82744 27.2925 3.86292 27.2423L3.8984 27.191C3.95753 27.1102 4.01371 27.0402 4.06791 26.9752L4.5114 26.4627L4.30641 26.4095L3.85208 26.2893C3.65103 26.2321 3.46871 26.172 3.29822 26.104C3.14448 26.038 2.97792 25.9503 2.79067 25.8389C2.60047 25.7256 2.43096 25.6033 2.2713 25.4634C2.10475 25.3244 1.95298 25.1727 1.81895 25.0111C1.65929 24.8268 1.52132 24.6346 1.40404 24.4365C1.28775 24.2384 1.18822 24.0255 1.10839 23.8038C1.02757 23.5899 0.964501 23.3583 0.924095 23.1317C0.884674 22.907 0.863978 22.6744 0.863978 22.4379C0.863978 22.1875 0.886645 21.9382 0.936907 21.6544C0.992096 21.3902 1.06897 21.1429 1.16949 20.9024C1.26706 20.6649 1.39025 20.4353 1.53709 20.2185C1.68985 19.9928 1.85049 19.7937 2.01704 19.6262L2.03182 19.6153L2.03971 19.6094L2.04562 19.6025C2.2378 19.4044 2.43392 19.2398 2.64383 19.0999C2.84389 18.9659 3.07155 18.8446 3.33961 18.7303C3.55642 18.6387 3.80675 18.5628 4.08368 18.5066C4.3409 18.4534 4.60108 18.4268 4.85929 18.4268C4.89772 18.4268 4.93517 18.4278 4.98445 18.4307L5.01697 18.4317C5.05048 18.4327 5.083 18.4337 5.11355 18.4337C5.19535 18.4376 5.27025 18.4455 5.34121 18.4573C5.4299 18.4662 5.50579 18.477 5.5797 18.4938C5.66347 18.5066 5.7433 18.5263 5.8182 18.546C5.84579 18.5519 5.86846 18.5588 5.89605 18.5667C5.93055 18.5766 5.96504 18.5854 5.98968 18.5904L6.18087 18.6534C6.20847 18.6603 6.23113 18.6692 6.26858 18.687L6.27745 18.6909L6.28632 18.6939C6.3011 18.6978 6.31293 18.7037 6.3287 18.7096H6.32968L6.3425 18.7146C6.35728 18.7205 6.37108 18.7254 6.38192 18.7293L7.00477 18.9964L6.99294 18.7835L6.96633 18.3144C6.96633 18.3105 6.96633 18.3065 6.96633 18.3026C6.96633 18.275 6.96535 18.2405 6.95746 18.2031L6.95549 18.0414V18.0316L6.95253 18.0198C6.94958 18.006 6.94958 17.9981 6.94958 17.9725C6.94958 17.7073 6.97619 17.4462 7.0294 17.189C7.08657 16.9081 7.16048 16.6647 7.25312 16.4449C7.36448 16.1827 7.4857 15.9551 7.62269 15.7491C7.77249 15.5264 7.942 15.3214 8.12728 15.141C8.32142 14.9469 8.52543 14.7784 8.73534 14.6374C8.94427 14.4916 9.1739 14.3674 9.42127 14.2659C9.67159 14.1644 9.9229 14.0875 10.1663 14.0373C10.4166 13.9929 10.6473 13.9693 10.866 13.9653H10.936C11.207 13.9653 11.4682 13.99 11.7146 14.0373C11.9521 14.0846 12.1916 14.1575 12.4655 14.2659C12.704 14.3645 12.9297 14.4857 13.1564 14.6374C13.3643 14.7764 13.5683 14.9449 13.7615 15.1391C13.9409 15.3175 14.1114 15.5224 14.2671 15.7481C14.4051 15.9679 14.5312 16.2044 14.6376 16.4459C14.7283 16.6607 14.8042 16.912 14.8604 17.188C14.9136 17.4452 14.9402 17.7064 14.9402 17.9636V17.9734C14.9402 17.9774 14.9402 17.9813 14.9392 17.9843L14.9353 18L14.9362 18.0109L14.9195 18.5825L14.9136 18.7757L15.0959 18.7096L15.5098 18.5588C15.5197 18.5549 15.5276 18.5529 15.5364 18.55C15.5699 18.5401 15.5887 18.5332 15.6025 18.5273L15.6389 18.5155C15.6626 18.5086 15.6764 18.5037 15.6971 18.4977C15.7326 18.4849 15.7601 18.477 15.7868 18.4701L15.8163 18.4623C15.8331 18.4583 15.8488 18.4534 15.8617 18.4485C15.8971 18.4396 15.9425 18.4278 16.0016 18.4159C16.0795 18.3992 16.1484 18.3874 16.2293 18.3745C16.2736 18.3637 16.314 18.3598 16.3643 18.3548L16.4352 18.347C16.4618 18.344 16.4884 18.342 16.516 18.3391L16.6698 18.3263C16.7368 18.3184 16.8068 18.3184 16.8758 18.3184C17.1379 18.3184 17.4001 18.346 17.6563 18.3992C17.9145 18.4514 18.1658 18.5273 18.4043 18.6239C18.6536 18.7254 18.8833 18.8506 19.0863 18.9944C19.2972 19.1324 19.5012 19.3009 19.6973 19.4971C19.8944 19.6942 20.0629 19.8991 20.1989 20.1061C20.3448 20.319 20.469 20.5506 20.5715 20.7989C20.6749 21.0542 20.7508 21.3055 20.7962 21.545C20.8464 21.7815 20.872 22.0505 20.872 22.3265C20.872 22.566 20.8533 22.8025 20.8169 23.0311C20.7646 23.2874 20.7035 23.5042 20.6237 23.7082C20.5498 23.9181 20.4532 24.1201 20.3192 24.3498C20.192 24.5646 20.056 24.7538 19.9033 24.9253C19.7584 25.0958 19.6047 25.2476 19.444 25.3777C19.2706 25.5216 19.1001 25.6438 18.9217 25.7522C18.7591 25.8448 18.5837 25.9305 18.4043 26.0045C18.2506 26.0695 18.0732 26.1296 17.8613 26.1897L17.1586 26.3602L17.6484 26.8885C17.6947 26.9407 17.741 26.9949 17.7893 27.0531L17.8445 27.1181C17.8977 27.1851 17.945 27.2531 18.0002 27.332L18.0121 27.3487C18.0801 27.4443 18.1441 27.5448 18.2033 27.6483C18.2604 27.7518 18.3205 27.8632 18.3659 27.9696C18.428 28.1076 18.4772 28.2347 18.5196 28.3707C18.5649 28.4959 18.5975 28.6328 18.626 28.7541L18.6329 28.7817C18.6389 28.8122 18.6448 28.8447 18.6517 28.8753C18.97 28.9275 19.2331 28.9817 19.4775 29.0438C19.4992 29.0487 19.5229 29.0546 19.5445 29.0606C19.5288 28.8911 19.4982 28.7284 19.4687 28.5915C19.4332 28.4426 19.3918 28.2721 19.3356 28.1026C19.2824 27.942 19.2183 27.7764 19.1503 27.6227C19.0833 27.4867 19.0183 27.3576 18.9523 27.2344C18.8793 27.1063 18.7975 26.9782 18.7197 26.8579L18.6921 26.8205L18.6891 26.8165L18.7315 26.8008C18.9907 26.6845 19.1848 26.5849 19.3504 26.4824C19.5524 26.3681 19.7614 26.2213 19.9861 26.038C20.196 25.8685 20.3813 25.6842 20.5508 25.4742C20.7223 25.2909 20.8898 25.0613 21.0554 24.7814C21.2071 24.5212 21.3274 24.269 21.4249 24.0107C21.5186 23.7683 21.5935 23.4973 21.6526 23.1859C21.7019 22.9227 21.7245 22.6488 21.7245 22.3225C21.7245 21.9973 21.6969 21.6889 21.6398 21.3804C21.5688 21.0473 21.4781 20.7506 21.3589 20.4708C21.2495 20.1928 21.0967 19.909 20.9075 19.6301C20.7341 19.3689 20.532 19.1206 20.3054 18.8949C20.0629 18.6515 19.8205 18.4504 19.5652 18.2839C19.313 18.1144 19.0321 17.9636 18.7335 17.8374C18.4102 17.7103 18.1136 17.6187 17.8209 17.5566C17.5104 17.4964 17.1931 17.4669 16.8777 17.4669C16.7841 17.4669 16.6964 17.4669 16.6195 17.4758C16.5417 17.4758 16.453 17.4836 16.3485 17.4994C16.2677 17.5073 16.1859 17.5191 16.0824 17.5339C15.9908 17.5516 15.9178 17.5635 15.8311 17.5773C15.8153 17.5812 15.7976 17.5851 15.7779 17.5901C15.7611 17.392 15.7345 17.2018 15.6971 17.0214C15.6409 16.7159 15.5463 16.4005 15.4251 16.1088C15.2979 15.8112 15.1511 15.5382 14.9776 15.2711C14.7766 14.9814 14.5775 14.7409 14.3666 14.534C14.1429 14.3063 13.8946 14.1023 13.6304 13.9279C13.3515 13.7387 13.0677 13.5869 12.7918 13.4775C12.5296 13.3632 12.232 13.2705 11.8861 13.1966C11.5855 13.1414 11.2681 13.1138 10.938 13.1138H10.866C10.6059 13.1138 10.324 13.1414 10.0017 13.1986C9.66174 13.2725 9.36706 13.3642 9.09604 13.4795C8.82108 13.5869 8.53725 13.7396 8.25539 13.9308C8.0031 14.0984 7.75475 14.3024 7.51822 14.5379C7.29451 14.7666 7.09248 15.0139 6.91607 15.2741C6.74065 15.5441 6.59479 15.8181 6.47061 16.1128C6.34447 16.4203 6.25281 16.7268 6.19762 17.0234C6.14736 17.2481 6.11681 17.4895 6.10499 17.7379C6.08035 17.732 6.05669 17.7261 6.03403 17.7211L5.9473 17.7004L5.91281 17.6936C5.85466 17.6798 5.7975 17.6669 5.74231 17.6571C5.64278 17.6364 5.54817 17.6226 5.44764 17.6118C5.33825 17.598 5.24364 17.5891 5.15593 17.5851C5.06329 17.5753 4.96474 17.5753 4.85929 17.5753C4.53012 17.5753 4.22067 17.6068 3.93979 17.6699L3.92994 17.6709L3.92304 17.6719L3.91614 17.6738C3.62048 17.729 3.31497 17.8217 3.00749 17.9468C2.70395 18.0749 2.4211 18.2257 2.16585 18.3943C1.87907 18.5963 1.63958 18.7964 1.42967 19.0063C1.18329 19.2625 0.987168 19.503 0.828499 19.7415C0.635337 20.0332 0.48948 20.3081 0.382058 20.5811C0.263795 20.859 0.172142 21.1577 0.101184 21.4898C0.0390961 21.8229 0.00854492 22.1333 0.00854492 22.4398C0.00854492 22.7256 0.035154 23.0095 0.0883722 23.2834C0.127793 23.5308 0.197765 23.791 0.307158 24.0994C0.39487 24.3389 0.50919 24.5843 0.667859 24.8711C0.808789 25.1066 0.9714 25.3304 1.1685 25.56C1.32816 25.7492 1.50851 25.9335 1.7204 26.1207C1.90962 26.2814 2.11362 26.4292 2.34916 26.5761C2.55513 26.7002 2.77885 26.8067 2.97004 26.8944C2.99566 26.9042 3.0203 26.9141 3.04494 26.924C3.03705 26.9387 3.02917 26.9515 3.02129 26.9663C2.95427 27.0649 2.88627 27.1812 2.82024 27.3122C2.75815 27.4197 2.69804 27.5448 2.64087 27.6877C2.58864 27.803 2.54626 27.9272 2.50881 28.0356L2.46348 28.1706C2.41913 28.3283 2.37971 28.4643 2.35507 28.6102C2.32551 28.7482 2.30383 28.9039 2.28116 29.0783C2.26441 29.2636 2.25751 29.4153 2.25751 29.5632C2.25751 29.8687 2.28904 30.1643 2.3462 30.4482C2.65369 30.5014 2.95329 30.5497 3.24894 30.5911Z"
                fill="black"
              />
              <path
                d="M29.909 43.1151H28.9646L27.0645 49.3616L25.1189 43.1151H24.2428L22.2972 49.3616L20.3971 43.1151H19.4641L21.8079 50.7383H22.7409L24.6865 44.5487L26.6208 50.7383H27.5651L29.909 43.1151Z"
                fill="black"
              />
              <path
                d="M40.3211 43.1151H39.4223V46.4944H34.8484V43.1151H33.9495V50.7383H34.8484V47.3022H39.4223V50.7383H40.3211V43.1151Z"
                fill="black"
              />
              <path
                d="M48.7444 42.9672C47.6294 42.9672 46.6964 43.3541 45.9341 44.1164C45.1718 44.8901 44.7963 45.8231 44.7963 46.9267C44.7963 48.0417 45.1718 48.9747 45.9341 49.737C46.6964 50.5107 47.6294 50.8862 48.7444 50.8862C49.8367 50.8862 50.7697 50.5107 51.532 49.737C52.2943 48.9747 52.6812 48.0417 52.6812 46.9267C52.6812 45.8231 52.2943 44.8901 51.532 44.1164C50.7697 43.3541 49.8367 42.9672 48.7444 42.9672ZM48.7444 50.0329C47.8797 50.0329 47.1629 49.737 46.5826 49.1454C45.991 48.5537 45.7066 47.8142 45.7066 46.9267C45.7066 46.062 45.991 45.3224 46.5826 44.7194C47.1629 44.1164 47.8797 43.8092 48.7444 43.8092C49.5864 43.8092 50.3032 44.1164 50.8948 44.7194C51.4751 45.3224 51.7709 46.062 51.7709 46.9267C51.7709 47.8142 51.4751 48.5537 50.8948 49.1454C50.3032 49.737 49.5864 50.0329 48.7444 50.0329Z"
                fill="black"
              />
              <path
                d="M62.4176 49.9191H58.0485V43.1151H57.1496V50.7383H62.4176V49.9191Z"
                fill="black"
              />
              <path
                d="M72.2246 49.9191H67.5596V47.3136H71.8832V46.5057H67.5596V43.923H72.2132V43.1151H66.6608V50.7383H72.2246V49.9191Z"
                fill="black"
              />
              <path
                d="M79.287 42.9672C78.4678 42.9672 77.8192 43.172 77.3186 43.5702C76.818 43.9799 76.5791 44.5032 76.5791 45.1518C76.5791 46.1758 77.1821 46.8243 78.4109 47.0974L80.1289 47.4728C80.5613 47.5752 80.8799 47.7118 81.0733 47.8824C81.2667 48.0645 81.3691 48.3262 81.3691 48.6675C81.3691 49.0999 81.1985 49.4412 80.8685 49.7029C80.5385 49.9646 80.0834 50.0897 79.5145 50.0897C78.9115 50.0897 78.4109 49.9532 78.0127 49.6574C77.6031 49.3616 77.3641 48.952 77.2845 48.4172L76.3401 48.6106C76.4311 49.3161 76.7611 49.8736 77.33 50.2832C77.8989 50.6928 78.6043 50.8862 79.4349 50.8862C80.2882 50.8862 80.9709 50.6814 81.4943 50.2718C82.0063 49.8622 82.268 49.3161 82.268 48.622C82.268 47.5752 81.6194 46.9153 80.3451 46.6423L78.684 46.2668C78.2971 46.1985 78.0127 46.0734 77.8192 45.8913C77.6258 45.7093 77.5348 45.459 77.5348 45.129C77.5348 44.7194 77.6941 44.3895 78.0127 44.1391C78.3312 43.8888 78.7409 43.7523 79.2642 43.7523C79.7876 43.7523 80.22 43.8888 80.5841 44.1619C80.9368 44.435 81.153 44.8104 81.244 45.2655L82.1428 45.0607C82.0063 44.4236 81.6877 43.923 81.1757 43.5361C80.6637 43.1606 80.0379 42.9672 79.287 42.9672Z"
                fill="black"
              />
              <path
                d="M93.4974 50.7383L90.084 43.1151H89.2534L85.8401 50.7383H86.8072L87.6605 48.8041H91.6769L92.5303 50.7383H93.4974ZM91.3242 47.9962H88.0133L89.6744 44.2302L91.3242 47.9962Z"
                fill="black"
              />
              <path
                d="M102.729 49.9191H98.3598V43.1151H97.4609V50.7383H102.729V49.9191Z"
                fill="black"
              />
              <path
                d="M112.536 49.9191H107.871V47.3136H112.195V46.5057H107.871V43.923H112.524V43.1151H106.972V50.7383H112.536V49.9191Z"
                fill="black"
              />
            </svg>
          </Grid>
        )}
      </Grid>
    );
  }

  function ClientMenu() {
    return (
      <Grid
        style={{
          width: wid < 1024 && '100%',
          padding: wid < 1024 && '0px 16px 8px',
        }}
        className={classes.dasboardMenu}
      >
        <Typography
          align="center"
          style={{
            fontSize: wid < 1024 ? 18 : 32,
            lineHeight: wid < 1024 ? '32px' : '48px',
            marginBottom: wid > 1024 && 24,
          }}
        >
          FARM RIO {wid > 1024 && <br />} APPLICATION
        </Typography>
        {wid > 1024 && (
          <Typography
            align="center"
            style={{
              fontSize: 14,
              lineHeight: '28px',
              width: 237,
            }}
          >
            {step > 2 ? (
              <span>
                It's good to see you again, your account has been set up! <br />{' '}
                <br /> In order to proceed and start placing your orders, we
                need some additional information.
              </span>
            ) : (
              <span>
                Fill out the form to sell Farm and <br /> we'll get back to you.
              </span>
            )}
          </Typography>
        )}
      </Grid>
    );
  }

  function StepOptions() {
    const handleTitle = () => {
      switch (step) {
        case 0:
          return 'Profile Information';
        case 1:
          return 'Account Information';
        case 2:
          return 'Business Information';
        case 3:
          return 'Billing Information';
        case 4:
          return 'Shipping Information';
        case 5:
          return 'Connected Users';
        default:
          return '';
      }
    };
    return wid > 1024 ? (
      <Grid container justifyContent="center">
        {step < 3 ? (
          <>
            <Grid item onClick={() => setStep(0)}>
              <Typography
                className={
                  step === 0 ? classes.stepOptionsSelected : classes.stepOptions
                }
              >
                Profile Information
              </Typography>
            </Grid>
            <Grid item onClick={() => step === 2 && setStep(1)}>
              <Typography
                style={{ margin: '0px 68px' }}
                className={
                  step < 1
                    ? classes.disabled
                    : step === 1
                    ? classes.stepOptionsSelected
                    : classes.stepOptions
                }
              >
                Account Information
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                className={
                  step < 2
                    ? classes.disabled
                    : step === 2
                    ? classes.stepOptionsSelected
                    : classes.stepOptions
                }
              >
                Business Information
              </Typography>
            </Grid>
          </>
        ) : (
          <>
            <Grid item onClick={() => setStep(3)}>
              <Typography
                className={
                  step === 3 ? classes.stepOptionsSelected : classes.stepOptions
                }
              >
                Billing Information
              </Typography>
            </Grid>
            <Grid item onClick={() => setStep(4)}>
              <Typography
                style={{ margin: '0px 68px' }}
                className={
                  step === 4 ? classes.stepOptionsSelected : classes.stepOptions
                }
              >
                Shipping Information
              </Typography>
            </Grid>
            <Grid item onClick={() => setStep(5)}>
              <Typography
                className={
                  step === 5 ? classes.stepOptionsSelected : classes.stepOptions
                }
              >
                Connected Users
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    ) : (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ height: 44, background: '#fff', paddingBottom: 12 }}
      >
        <Typography
          style={{
            border: 0,
            fontSize: 14,
            lineHeight: '14px',
            fontWeight: 'bold',
          }}
        >
          {handleTitle()}
        </Typography>
      </Grid>
    );
  }

  return (
    <>
      <ModalMessage
        open={openMessage}
        onClose={() => setOpenMessage(false)}
        user={user}
      />
      <HeaderContent step={step} />
      <Grid
        container
        justifyContent="space-between"
        alignItems="flex-start"
        className={
          wid > 1024 ? classes.dashboardContent : classes.dashboardContentMobile
        }
      >
        <ClientMenu />
        <Grid
          container
          justifyContent={wid < 1024 && 'center'}
          className={wid > 1024 ? classes.container : classes.containerMobile}
        >
          {step !== 'sent' && <StepOptions />}
          {step === 0 && (
            <Profile
              width={wid}
              state={state}
              handleChange={handleChange}
              error={error}
              country={country}
            />
          )}
          {step === 1 && (
            <Account
              width={wid}
              state={state}
              handleChange={handleChange}
              error={error}
            />
          )}
          {step === 2 && (
            <Business
              state={state}
              error={error}
              handleChange={handleChange}
              handleChangeRadio={handleChangeRadio}
              handleChangeBuyingSeason={handleChangeBuyingSeason}
              handleChangeInterest={handleChangeInterest}
              arrayBuyingSeason={arrayBuyingSeason}
              arrayInterest={arrayInterest}
              setState={setState}
              setError={setError}
              changeDocuments={changeDocuments}
              width={wid}
            />
          )}
          {step === 'sent' && <Sent width={wid} />}
          {(step === 3 || step === 4) && (
            <Addresses
              state={state}
              setState={setState}
              step={step}
              handleChange={handleChange}
              country={country}
              width={wid}
            />
          )}
          {step === 5 && (
            <Users
              state={state}
              setState={setState}
              step={step}
              handleChange={handleChange}
              country={country}
              handleAddUser={handleAddUser}
              width={wid}
            />
          )}
        </Grid>
      </Grid>
      {step !== 'sent' && (
        <NavBar
          handleNext={handleNext}
          step={step}
          setStep={setStep}
          isApproved={state.isApproved}
          loading={state.loading}
        />
      )}
    </>
  );
}
